module.exports = __webpack_public_path__ + "assets/img/chronicleImgActive-d779a1c9.png";